/* eslint-disable no-param-reassign */
const clsPrefix = 'markdown-highlight';
export const builtType = ['purple', 'yellow', 'orange', 'red', 'blue', 'green', 'gray'] as const;

export function isSupportHighlightType(type: string): type is (typeof builtType)[number] {
  return builtType.includes(type as any);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function remarkHighlight(node: any, hast: any) {
  const sourceName = (node.name as string)
    .trim()
    .split(' ')
    .filter((item) => Boolean(item));
  sourceName.shift();
  const type: any = sourceName[0];
  if (!isSupportHighlightType(type)) return;

  const emojiText = sourceName[1] && sourceName[1].codePointAt(0);
  hast.properties.className = [clsPrefix];

  if (emojiText) {
    node.children = [
      {
        type: 'containerDirective',
        children: [
          {
            type: 'paragraph',
            children: [
              {
                type: 'text',
                value: String.fromCodePoint(emojiText),
              },
            ],
            data: {
              hProperties: {
                className: ['text-center'],
                style: 'min-width: 16px; padding: 0px;margin-top:0px;margin-bottom:0px;',
              },
            },
          },
          {
            type: 'paragraph',
            children: node.children[0].children,
            data: {
              hProperties: {
                style:
                  'width: fit-content;word-break: break-word; padding: 0px; margin-left: 8px;margin-top:0px;margin-bottom:0px;',
              },
            },
          },
        ],
        data: {
          hProperties: {
            className: ['flex'],
          },
        },
      },
    ];
  }

  hast.properties.className.push(`${clsPrefix}-${type}`);
}
